<header
  [class]="!(stick && sticky) ? class : ''"
  [ngClass]="stick && sticky ? 'sticky fixed' : ''"
>
  @if (topBarSection?.visible) {
    <app-top-bar  [section]="topBarSection"></app-top-bar>
  }
  @if (secondBarSection?.visible) {
    <app-second-bar  [section]="secondBarSection"></app-second-bar>
  }
</header>
